module.exports = __webpack_public_path__ + "static/media/c_02.770e4e8a.png";